module.exports = __webpack_public_path__ + "static/media/deaths_brother.e86f90fc.jpg";